import { createSelector } from 'reselect';
import { CzasNaDesignStore } from '../store.types';

const cookiePolicyPopup = (state: CzasNaDesignStore) => state.cookiePolicyPopup;

export const selectIsCookiePopupVisible = createSelector(
  [cookiePolicyPopup],
  cookiePolicyPopup => { return cookiePolicyPopup.isPopupVisible }
);